import { rootStore } from "../store";

export const checkResponseStatusAndLogOut = async () => {
  const { authStore } = rootStore;
   await authStore.refresh();
};
